export default __webpack_public_path__ + "static/media/DNS_Dashboard.23b09cc8.svg";